import { render, staticRenderFns } from "./FeedbackContactsView.vue?vue&type=template&id=4cfa5947"
import script from "./FeedbackContactsView.vue?vue&type=script&lang=ts"
export * from "./FeedbackContactsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports